// extracted by mini-css-extract-plugin
module.exports = {"panel":"CenteredPane_panel__17RD5"};